import { capitalizeFirstLetter } from '../utils';

export function maybeResponseId(response) {
  if (response && response.data && response.data.id) {
    return response.data.id;
  }

  return null;
}

export function maybeResponseError(response) {
  if (response.statusCode < 400) {
    return null;
  }

  if (response && response.data && response.data.description) {
    // We don't want the api to have any opinion on formatting
    // for errors, so we capitalise it here. We may wish to
    // wrap server errors, or include them in other error strings
    return new Error(capitalizeFirstLetter(response.data.description));
  }

  return new Error('Undefined API error');
}

export function checkForResponseError(response) {
  const error = maybeResponseError(response);

  if (error) {
    throw error;
  }
}

export function generateResponsePayload(type, newItem, path) {
  return {
    [type]: newItem,
    ...path.reduce((a, b) => {
      return {
        ...a,
        [b.key]: b.value,
      };
    }, {}),
  };
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/utils/http.js